<script setup lang="ts">
defineProps<{ name: string }>()
</script>

<template>
  <svg class="vf-app-icon" viewBox="0 0 24 24" aria-hidden="true">
    <template v-if="name === 'home'">
      <path d="m3 11 9-8 9 8" /><path d="M5 10v10h14V10" /><path d="M9 20v-6h6v6" />
    </template>
    <template v-else-if="name === 'back'">
      <path d="m15 5-7 7 7 7" />
    </template>
    <template v-else-if="name === 'bell'">
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" /><path d="M10 21h4" />
    </template>
    <template v-else-if="name === 'sun'">
      <circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </template>
    <template v-else-if="name === 'moon'">
      <path d="M20 15.2A8.5 8.5 0 0 1 8.8 4 8.5 8.5 0 1 0 20 15.2Z" />
    </template>
    <template v-else-if="name === 'palette'">
      <path d="M12 3a9 9 0 1 0 0 18h1.4a2 2 0 0 0 1.2-3.6l-.8-.6a1.6 1.6 0 0 1 1-2.9H18a3 3 0 0 0 3-3A9 9 0 0 0 12 3Z" /><circle cx="7.5" cy="10" r=".8" /><circle cx="10" cy="6.8" r=".8" /><circle cx="14.2" cy="6.8" r=".8" /><circle cx="17" cy="9.8" r=".8" />
    </template>
    <template v-else-if="name === 'entry'">
      <path d="M5 19 19 5" /><path d="M9 5h10v10" /><path d="M5 12h8" />
    </template>
    <template v-else-if="name === 'exit'">
      <path d="M19 5 5 19" /><path d="M5 9v10h10" /><path d="M11 5h8v8" />
    </template>
    <template v-else-if="name === 'overview'">
      <path d="M4 7l5-2 6 2 5-2v12l-5 2-6-2-5 2z" /><path d="M9 5v12" /><path d="M15 7v12" />
    </template>
    <template v-else-if="name === 'service'">
      <path d="M5 8h14" /><path d="M7 4h10l2 4v11a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V8z" /><path d="M9 12h6" /><path d="M9 16h4" />
    </template>
    <template v-else-if="name === 'service-bag'">
      <path d="M7 9V7a5 5 0 0 1 10 0v2" /><rect x="5" y="9" width="14" height="11" rx="2" /><path d="M9 14h6" />
    </template>
    <template v-else-if="name === 'dining'">
      <path d="M7 3v8" /><path d="M10 3v8" /><path d="M7 7h3" /><path d="M8.5 11v10" /><path d="M16 3v18" /><path d="M16 3c3 2 4 5 2 8h-2" />
    </template>
    <template v-else-if="name === 'restroom'">
      <circle cx="8" cy="5" r="2" /><circle cx="16" cy="5" r="2" /><path d="M6 21v-7H4l2-6h4l2 6h-2v7" /><path d="M15 21v-6h-2l1-7h4l1 7h-2v6" />
    </template>
    <template v-else-if="name === 'shopping'">
      <path d="M5 10h14l-1-5H6z" /><path d="M6 10v10h12V10" /><path d="M9 20v-5h6v5" /><path d="M4 10c1 2 3 2 4 0 1 2 3 2 4 0 1 2 3 2 4 0 1 2 3 2 4 0" />
    </template>
    <template v-else-if="name === 'lost-found'">
      <path d="M5 7h14v13H5z" /><path d="M8 7V5h8v2" /><circle cx="12" cy="13" r="3" /><path d="m14.2 15.2 2.3 2.3" />
    </template>
    <template v-else-if="name === 'vr'">
      <path d="M3 8.5A2.5 2.5 0 0 1 5.5 6h13A2.5 2.5 0 0 1 21 8.5v7a2.5 2.5 0 0 1-2.5 2.5h-3.2l-2.1-3.2a1.45 1.45 0 0 0-2.4 0L8.7 18H5.5A2.5 2.5 0 0 1 3 15.5z" /><circle cx="7.5" cy="11.5" r="1.8" /><circle cx="16.5" cy="11.5" r="1.8" />
    </template>
    <template v-else-if="name === 'notice'">
      <path d="M6 3h12v18H6z" /><path d="M9 8h6" /><path d="M9 12h6" /><path d="M9 16h4" />
    </template>
    <template v-else-if="name === 'history'">
      <path d="M4 12a8 8 0 1 0 2-5.3" /><path d="M4 5v5h5" /><path d="M12 8v5l3 2" />
    </template>
    <template v-else-if="name === 'search'">
      <circle cx="10.5" cy="10.5" r="6.5" /><path d="m15.5 15.5 5 5" />
    </template>
    <template v-else-if="name === 'handover'">
      <path d="M3 14h4l3 3h7l4-4-2-2-4 3h-4" /><path d="M7 14V8h8l2 3" />
    </template>
    <template v-else-if="name === 'id-card'">
      <rect x="3" y="5" width="18" height="14" rx="2" /><circle cx="8" cy="11" r="2" /><path d="M5.5 16c.8-2 4.2-2 5 0" /><path d="M13 10h5" /><path d="M13 14h4" />
    </template>
    <template v-else-if="name === 'metro'">
      <rect x="6" y="3" width="12" height="14" rx="3" /><path d="M9 7h6" /><path d="M8 12h2" /><path d="M14 12h2" /><path d="m9 21 2-4" /><path d="m15 21-2-4" />
    </template>
    <template v-else-if="name === 'drive' || name === 'ridehail'">
      <path d="M6 16h12" /><path d="m7 16 1.5-5h7L17 16" /><path d="M7 16v3" /><path d="M17 16v3" /><path d="M8 19h.01" /><path d="M16 19h.01" />
    </template>
    <template v-else>
      <path d="M4 17h7" /><path d="M13 7h7" /><path d="m8 13 3 4-3 4" /><path d="m16 3-3 4 3 4" />
    </template>
  </svg>
</template>
